<!--
 * @Author: zhangzhitao
 * @Date: 2019-10-22 09:35:42
 * @LastEditors: zhangzhitao
 * @LastEditTime: 2019-12-03 13:56:24
 * @Description: 组件菜单menuItem
 -->
<template>
  <el-submenu
    v-if="!data.fullUrl&&data.children && data.children.length && data.isShow === 0"
    class="u-level-2"
    :index="data.menuId"
  >
    <template v-slot:title>
      <span :title="data.name">{{ data.name }}</span>
    </template>
    <menu-item
      v-for="(sub, index) in data.children"
      :key="index"
      :data="sub"
      no-icon
    ></menu-item>
  </el-submenu>
  <el-menu-item
    v-else-if="data.name !== '-'"
    v-show="data.isShow === 0"
    :index="data.menuId"
    :title="data.name"
  >
    {{ data.name }}
  </el-menu-item>
  <div
    class="u-cut-line u-cut-line-color"
    :key="data.id"
    v-else
  ></div>
</template>

<script>
export default {
  name: 'menu-item',
  props: {
    data: Object,
    noIcon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultIcon: `this.src="${require('../../assets/images/nav_icondefault_B.png')}"`
    }
  }
}
</script>

<style lang="less" scoped>
.u-cut-line {
  width: calc(~"100% - 16px");
  height: 1px;
  margin: 4px 8px;
}
</style>
